// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as privateBookRouteRouteImport } from './routes/(private)/book/route'
import { Route as privateDietRouteRouteImport } from './routes/(private)/diet/route'
import { Route as privateGymsRouteRouteImport } from './routes/(private)/gyms/route'
import { Route as privateTrainingRouteRouteImport } from './routes/(private)/training/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicTrainerSlugRouteRouteImport } from './routes/(public)/$trainerSlug/route'
import { Route as ConsentIndexRouteImport } from './routes/consent/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as privateBookIndexRouteImport } from './routes/(private)/book/index'
import { Route as privateDashboardIndexRouteImport } from './routes/(private)/dashboard/index'
import { Route as privateDietIndexRouteImport } from './routes/(private)/diet/index'
import { Route as privateDietPlanIdRouteImport } from './routes/(private)/diet/$planId'
import { Route as privateEventsIndexRouteImport } from './routes/(private)/events/index'
import { Route as privateGymPlacesPlaceIdRouteImport } from './routes/(private)/gym-places/$placeId'
import { Route as privateGymsIndexRouteImport } from './routes/(private)/gyms/index'
import { Route as privateGymsGymIdRouteImport } from './routes/(private)/gyms/$gymId'
import { Route as privateMyBookingsIndexRouteImport } from './routes/(private)/my-bookings/index'
import { Route as privateMyPaymentsIndexRouteImport } from './routes/(private)/my-payments/index'
import { Route as privateNotificationsIndexRouteImport } from './routes/(private)/notifications/index'
import { Route as privateProgressIndexRouteImport } from './routes/(private)/progress/index'
import { Route as privateSettingsIndexRouteImport } from './routes/(private)/settings/index'
import { Route as privateTrainingIndexRouteImport } from './routes/(private)/training/index'
import { Route as privateTrainingHistoryRouteRouteImport } from './routes/(private)/training/history/route'
import { Route as privateTrainingSettingsRouteImport } from './routes/(private)/training/settings'
import { Route as privateTrainingSetupRouteImport } from './routes/(private)/training/setup'
import { Route as privateTrainingWorkoutRouteImport } from './routes/(private)/training/workout'
import { Route as publicTrainerSlugIndexRouteImport } from './routes/(public)/$trainerSlug/index'
import { Route as publicBlogIndexRouteImport } from './routes/(public)/blog/index'
import { Route as publicCallbackIndexRouteImport } from './routes/(public)/callback/index'
import { Route as publicCoachesIndexRouteImport } from './routes/(public)/coaches/index'
import { Route as publicConsumerHealthDataIndexRouteImport } from './routes/(public)/consumer-health-data/index'
import { Route as publicContactIndexRouteImport } from './routes/(public)/contact/index'
import { Route as publicContentPolicyIndexRouteImport } from './routes/(public)/content-policy/index'
import { Route as publicCookiesIndexRouteImport } from './routes/(public)/cookies/index'
import { Route as publicFeaturesIndexRouteImport } from './routes/(public)/features/index'
import { Route as publicHelpIndexRouteImport } from './routes/(public)/help/index'
import { Route as publicHelpSlugRouteImport } from './routes/(public)/help/$slug'
import { Route as publicHowItWorksIndexRouteImport } from './routes/(public)/how-it-works/index'
import { Route as publicJoinIndexRouteImport } from './routes/(public)/join/index'
import { Route as publicLegalIndexRouteImport } from './routes/(public)/legal/index'
import { Route as publicLoginIndexRouteImport } from './routes/(public)/login/index'
import { Route as publicLogoutIndexRouteImport } from './routes/(public)/logout/index'
import { Route as publicNewPasswordIndexRouteImport } from './routes/(public)/new-password/index'
import { Route as publicPricingIndexRouteImport } from './routes/(public)/pricing/index'
import { Route as publicPrivacyIndexRouteImport } from './routes/(public)/privacy/index'
import { Route as publicSearchIndexRouteImport } from './routes/(public)/search/index'
import { Route as publicSignupIndexRouteImport } from './routes/(public)/signup/index'
import { Route as publicTSplatRouteImport } from './routes/(public)/t/$'
import { Route as publicTermsIndexRouteImport } from './routes/(public)/terms/index'
import { Route as publicWhoItsForIndexRouteImport } from './routes/(public)/who-its-for/index'
import { Route as publicWithdrawalIndexRouteImport } from './routes/(public)/withdrawal/index'
import { Route as privateBookSpecialistIdIndexRouteImport } from './routes/(private)/book/$specialistId/index'
import { Route as privatePayOrderIdIndexRouteImport } from './routes/(private)/pay/$orderId/index'
import { Route as privatePaymentsReturnIndexRouteImport } from './routes/(private)/payments/return/index'
import { Route as privateTrainingCoachedTrainingIdRouteImport } from './routes/(private)/training/coached/$trainingId'
import { Route as privateTrainingHistoryIndexRouteImport } from './routes/(private)/training/history/index'
import { Route as privateTrainingHistoryWorkoutIdRouteImport } from './routes/(private)/training/history/$workoutId'
import { Route as publicTrainerSlugCoachesIndexRouteImport } from './routes/(public)/$trainerSlug/coaches/index'
import { Route as publicTrainerSlugContactIndexRouteImport } from './routes/(public)/$trainerSlug/contact/index'
import { Route as publicTrainerSlugPricingIndexRouteImport } from './routes/(public)/$trainerSlug/pricing/index'
import { Route as publicTrainerSlugServicesIndexRouteImport } from './routes/(public)/$trainerSlug/services/index'
import { Route as publicTrainerSlugShopIndexRouteImport } from './routes/(public)/$trainerSlug/shop/index'
import { Route as publicBlogSlugIndexRouteImport } from './routes/(public)/blog/$slug/index'
import { Route as publicBlogAuthorAuthorSlugRouteImport } from './routes/(public)/blog/author/$authorSlug'
import { Route as publicBlogCategoryCategorySlugRouteImport } from './routes/(public)/blog/category/$categorySlug'
import { Route as publicBookingConfirmIndexRouteImport } from './routes/(public)/booking/confirm/index'
import { Route as publicBookingVerifyIndexRouteImport } from './routes/(public)/booking/verify/index'
import { Route as publicSearchServiceIndexRouteImport } from './routes/(public)/search/$service/index'
import { Route as publicTrainerSlugServicesSlugIndexRouteImport } from './routes/(public)/$trainerSlug/services/$slug/index'
import { Route as publicTrainerSlugShopProductIdIndexRouteImport } from './routes/(public)/$trainerSlug/shop/$productId/index'
import { Route as publicSearchServiceCityIndexRouteImport } from './routes/(public)/search/$service/$city/index'

const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const privateBookRouteRoute = privateBookRouteRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => privateRouteRoute
          })
const privateDietRouteRoute = privateDietRouteRouteImport.update({
            id: '/diet',path: '/diet',getParentRoute: () => privateRouteRoute
          })
const privateGymsRouteRoute = privateGymsRouteRouteImport.update({
            id: '/gyms',path: '/gyms',getParentRoute: () => privateRouteRoute
          })
const privateTrainingRouteRoute = privateTrainingRouteRouteImport.update({
            id: '/training',path: '/training',getParentRoute: () => privateRouteRoute
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/(public)/',path: '/',getParentRoute: () => rootRouteImport
          })
const publicTrainerSlugRouteRoute = publicTrainerSlugRouteRouteImport.update({
            id: '/(public)/$trainerSlug',path: '/$trainerSlug',getParentRoute: () => rootRouteImport
          })
const ConsentIndexRoute = ConsentIndexRouteImport.update({
            id: '/consent/',path: '/consent/',getParentRoute: () => rootRouteImport
          })
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardingRouteRoute
          })
const privateBookIndexRoute = privateBookIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBookRouteRoute
          })
const privateDashboardIndexRoute = privateDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => privateRouteRoute
          })
const privateDietIndexRoute = privateDietIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateDietRouteRoute
          })
const privateDietPlanIdRoute = privateDietPlanIdRouteImport.update({
            id: '/$planId',path: '/$planId',getParentRoute: () => privateDietRouteRoute
          })
const privateEventsIndexRoute = privateEventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => privateRouteRoute
          })
const privateGymPlacesPlaceIdRoute = privateGymPlacesPlaceIdRouteImport.update({
            id: '/gym-places/$placeId',path: '/gym-places/$placeId',getParentRoute: () => privateRouteRoute
          })
const privateGymsIndexRoute = privateGymsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateGymsRouteRoute
          })
const privateGymsGymIdRoute = privateGymsGymIdRouteImport.update({
            id: '/$gymId',path: '/$gymId',getParentRoute: () => privateGymsRouteRoute
          })
const privateMyBookingsIndexRoute = privateMyBookingsIndexRouteImport.update({
            id: '/my-bookings/',path: '/my-bookings/',getParentRoute: () => privateRouteRoute
          })
const privateMyPaymentsIndexRoute = privateMyPaymentsIndexRouteImport.update({
            id: '/my-payments/',path: '/my-payments/',getParentRoute: () => privateRouteRoute
          })
const privateNotificationsIndexRoute = privateNotificationsIndexRouteImport.update({
            id: '/notifications/',path: '/notifications/',getParentRoute: () => privateRouteRoute
          })
const privateProgressIndexRoute = privateProgressIndexRouteImport.update({
            id: '/progress/',path: '/progress/',getParentRoute: () => privateRouteRoute
          })
const privateSettingsIndexRoute = privateSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => privateRouteRoute
          })
const privateTrainingIndexRoute = privateTrainingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTrainingRouteRoute
          })
const privateTrainingHistoryRouteRoute = privateTrainingHistoryRouteRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => privateTrainingRouteRoute
          })
const privateTrainingSettingsRoute = privateTrainingSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => privateTrainingRouteRoute
          })
const privateTrainingSetupRoute = privateTrainingSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => privateTrainingRouteRoute
          })
const privateTrainingWorkoutRoute = privateTrainingWorkoutRouteImport.update({
            id: '/workout',path: '/workout',getParentRoute: () => privateTrainingRouteRoute
          })
const publicTrainerSlugIndexRoute = publicTrainerSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicBlogIndexRoute = publicBlogIndexRouteImport.update({
            id: '/(public)/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const publicCallbackIndexRoute = publicCallbackIndexRouteImport.update({
            id: '/(public)/callback/',path: '/callback/',getParentRoute: () => rootRouteImport
          })
const publicCoachesIndexRoute = publicCoachesIndexRouteImport.update({
            id: '/(public)/coaches/',path: '/coaches/',getParentRoute: () => rootRouteImport
          })
const publicConsumerHealthDataIndexRoute = publicConsumerHealthDataIndexRouteImport.update({
            id: '/(public)/consumer-health-data/',path: '/consumer-health-data/',getParentRoute: () => rootRouteImport
          })
const publicContactIndexRoute = publicContactIndexRouteImport.update({
            id: '/(public)/contact/',path: '/contact/',getParentRoute: () => rootRouteImport
          })
const publicContentPolicyIndexRoute = publicContentPolicyIndexRouteImport.update({
            id: '/(public)/content-policy/',path: '/content-policy/',getParentRoute: () => rootRouteImport
          })
const publicCookiesIndexRoute = publicCookiesIndexRouteImport.update({
            id: '/(public)/cookies/',path: '/cookies/',getParentRoute: () => rootRouteImport
          })
const publicFeaturesIndexRoute = publicFeaturesIndexRouteImport.update({
            id: '/(public)/features/',path: '/features/',getParentRoute: () => rootRouteImport
          })
const publicHelpIndexRoute = publicHelpIndexRouteImport.update({
            id: '/(public)/help/',path: '/help/',getParentRoute: () => rootRouteImport
          })
const publicHelpSlugRoute = publicHelpSlugRouteImport.update({
            id: '/(public)/help/$slug',path: '/help/$slug',getParentRoute: () => rootRouteImport
          })
const publicHowItWorksIndexRoute = publicHowItWorksIndexRouteImport.update({
            id: '/(public)/how-it-works/',path: '/how-it-works/',getParentRoute: () => rootRouteImport
          })
const publicJoinIndexRoute = publicJoinIndexRouteImport.update({
            id: '/(public)/join/',path: '/join/',getParentRoute: () => rootRouteImport
          })
const publicLegalIndexRoute = publicLegalIndexRouteImport.update({
            id: '/(public)/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const publicLoginIndexRoute = publicLoginIndexRouteImport.update({
            id: '/(public)/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const publicLogoutIndexRoute = publicLogoutIndexRouteImport.update({
            id: '/(public)/logout/',path: '/logout/',getParentRoute: () => rootRouteImport
          })
const publicNewPasswordIndexRoute = publicNewPasswordIndexRouteImport.update({
            id: '/(public)/new-password/',path: '/new-password/',getParentRoute: () => rootRouteImport
          })
const publicPricingIndexRoute = publicPricingIndexRouteImport.update({
            id: '/(public)/pricing/',path: '/pricing/',getParentRoute: () => rootRouteImport
          })
const publicPrivacyIndexRoute = publicPrivacyIndexRouteImport.update({
            id: '/(public)/privacy/',path: '/privacy/',getParentRoute: () => rootRouteImport
          })
const publicSearchIndexRoute = publicSearchIndexRouteImport.update({
            id: '/(public)/search/',path: '/search/',getParentRoute: () => rootRouteImport
          })
const publicSignupIndexRoute = publicSignupIndexRouteImport.update({
            id: '/(public)/signup/',path: '/signup/',getParentRoute: () => rootRouteImport
          })
const publicTSplatRoute = publicTSplatRouteImport.update({
            id: '/(public)/t/$',path: '/t/$',getParentRoute: () => rootRouteImport
          })
const publicTermsIndexRoute = publicTermsIndexRouteImport.update({
            id: '/(public)/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const publicWhoItsForIndexRoute = publicWhoItsForIndexRouteImport.update({
            id: '/(public)/who-its-for/',path: '/who-its-for/',getParentRoute: () => rootRouteImport
          })
const publicWithdrawalIndexRoute = publicWithdrawalIndexRouteImport.update({
            id: '/(public)/withdrawal/',path: '/withdrawal/',getParentRoute: () => rootRouteImport
          })
const privateBookSpecialistIdIndexRoute = privateBookSpecialistIdIndexRouteImport.update({
            id: '/$specialistId/',path: '/$specialistId/',getParentRoute: () => privateBookRouteRoute
          })
const privatePayOrderIdIndexRoute = privatePayOrderIdIndexRouteImport.update({
            id: '/pay/$orderId/',path: '/pay/$orderId/',getParentRoute: () => privateRouteRoute
          })
const privatePaymentsReturnIndexRoute = privatePaymentsReturnIndexRouteImport.update({
            id: '/payments/return/',path: '/payments/return/',getParentRoute: () => privateRouteRoute
          })
const privateTrainingCoachedTrainingIdRoute = privateTrainingCoachedTrainingIdRouteImport.update({
            id: '/coached/$trainingId',path: '/coached/$trainingId',getParentRoute: () => privateTrainingRouteRoute
          })
const privateTrainingHistoryIndexRoute = privateTrainingHistoryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTrainingHistoryRouteRoute
          })
const privateTrainingHistoryWorkoutIdRoute = privateTrainingHistoryWorkoutIdRouteImport.update({
            id: '/$workoutId',path: '/$workoutId',getParentRoute: () => privateTrainingHistoryRouteRoute
          })
const publicTrainerSlugCoachesIndexRoute = publicTrainerSlugCoachesIndexRouteImport.update({
            id: '/coaches/',path: '/coaches/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicTrainerSlugContactIndexRoute = publicTrainerSlugContactIndexRouteImport.update({
            id: '/contact/',path: '/contact/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicTrainerSlugPricingIndexRoute = publicTrainerSlugPricingIndexRouteImport.update({
            id: '/pricing/',path: '/pricing/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicTrainerSlugServicesIndexRoute = publicTrainerSlugServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicTrainerSlugShopIndexRoute = publicTrainerSlugShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicBlogSlugIndexRoute = publicBlogSlugIndexRouteImport.update({
            id: '/(public)/blog/$slug/',path: '/blog/$slug/',getParentRoute: () => rootRouteImport
          })
const publicBlogAuthorAuthorSlugRoute = publicBlogAuthorAuthorSlugRouteImport.update({
            id: '/(public)/blog/author/$authorSlug',path: '/blog/author/$authorSlug',getParentRoute: () => rootRouteImport
          })
const publicBlogCategoryCategorySlugRoute = publicBlogCategoryCategorySlugRouteImport.update({
            id: '/(public)/blog/category/$categorySlug',path: '/blog/category/$categorySlug',getParentRoute: () => rootRouteImport
          })
const publicBookingConfirmIndexRoute = publicBookingConfirmIndexRouteImport.update({
            id: '/(public)/booking/confirm/',path: '/booking/confirm/',getParentRoute: () => rootRouteImport
          })
const publicBookingVerifyIndexRoute = publicBookingVerifyIndexRouteImport.update({
            id: '/(public)/booking/verify/',path: '/booking/verify/',getParentRoute: () => rootRouteImport
          })
const publicSearchServiceIndexRoute = publicSearchServiceIndexRouteImport.update({
            id: '/(public)/search/$service/',path: '/search/$service/',getParentRoute: () => rootRouteImport
          })
const publicTrainerSlugServicesSlugIndexRoute = publicTrainerSlugServicesSlugIndexRouteImport.update({
            id: '/services/$slug/',path: '/services/$slug/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicTrainerSlugShopProductIdIndexRoute = publicTrainerSlugShopProductIdIndexRouteImport.update({
            id: '/shop/$productId/',path: '/shop/$productId/',getParentRoute: () => publicTrainerSlugRouteRoute
          })
const publicSearchServiceCityIndexRoute = publicSearchServiceCityIndexRouteImport.update({
            id: '/(public)/search/$service/$city/',path: '/search/$service/$city/',getParentRoute: () => rootRouteImport
          })





const privateBookRouteRouteChildren = {
  privateBookIndexRoute: privateBookIndexRoute,privateBookSpecialistIdIndexRoute: privateBookSpecialistIdIndexRoute
}

const privateBookRouteRouteWithChildren = privateBookRouteRoute._addFileChildren(privateBookRouteRouteChildren)




const privateDietRouteRouteChildren = {
  privateDietPlanIdRoute: privateDietPlanIdRoute,privateDietIndexRoute: privateDietIndexRoute
}

const privateDietRouteRouteWithChildren = privateDietRouteRoute._addFileChildren(privateDietRouteRouteChildren)




const privateGymsRouteRouteChildren = {
  privateGymsGymIdRoute: privateGymsGymIdRoute,privateGymsIndexRoute: privateGymsIndexRoute
}

const privateGymsRouteRouteWithChildren = privateGymsRouteRoute._addFileChildren(privateGymsRouteRouteChildren)




const privateTrainingHistoryRouteRouteChildren = {
  privateTrainingHistoryWorkoutIdRoute: privateTrainingHistoryWorkoutIdRoute,privateTrainingHistoryIndexRoute: privateTrainingHistoryIndexRoute
}

const privateTrainingHistoryRouteRouteWithChildren = privateTrainingHistoryRouteRoute._addFileChildren(privateTrainingHistoryRouteRouteChildren)



const privateTrainingRouteRouteChildren = {
  privateTrainingHistoryRouteRoute: privateTrainingHistoryRouteRouteWithChildren,privateTrainingSettingsRoute: privateTrainingSettingsRoute,privateTrainingSetupRoute: privateTrainingSetupRoute,privateTrainingWorkoutRoute: privateTrainingWorkoutRoute,privateTrainingIndexRoute: privateTrainingIndexRoute,privateTrainingCoachedTrainingIdRoute: privateTrainingCoachedTrainingIdRoute
}

const privateTrainingRouteRouteWithChildren = privateTrainingRouteRoute._addFileChildren(privateTrainingRouteRouteChildren)



const privateRouteRouteChildren = {
  privateBookRouteRoute: privateBookRouteRouteWithChildren,privateDietRouteRoute: privateDietRouteRouteWithChildren,privateGymsRouteRoute: privateGymsRouteRouteWithChildren,privateTrainingRouteRoute: privateTrainingRouteRouteWithChildren,privateGymPlacesPlaceIdRoute: privateGymPlacesPlaceIdRoute,privateDashboardIndexRoute: privateDashboardIndexRoute,privateEventsIndexRoute: privateEventsIndexRoute,privateMyBookingsIndexRoute: privateMyBookingsIndexRoute,privateMyPaymentsIndexRoute: privateMyPaymentsIndexRoute,privateNotificationsIndexRoute: privateNotificationsIndexRoute,privateProgressIndexRoute: privateProgressIndexRoute,privateSettingsIndexRoute: privateSettingsIndexRoute,privatePayOrderIdIndexRoute: privatePayOrderIdIndexRoute,privatePaymentsReturnIndexRoute: privatePaymentsReturnIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)




const OnboardingRouteRouteChildren = {
  OnboardingIndexRoute: OnboardingIndexRoute
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(OnboardingRouteRouteChildren)




const publicTrainerSlugRouteRouteChildren = {
  publicTrainerSlugIndexRoute: publicTrainerSlugIndexRoute,publicTrainerSlugCoachesIndexRoute: publicTrainerSlugCoachesIndexRoute,publicTrainerSlugContactIndexRoute: publicTrainerSlugContactIndexRoute,publicTrainerSlugPricingIndexRoute: publicTrainerSlugPricingIndexRoute,publicTrainerSlugServicesIndexRoute: publicTrainerSlugServicesIndexRoute,publicTrainerSlugShopIndexRoute: publicTrainerSlugShopIndexRoute,publicTrainerSlugServicesSlugIndexRoute: publicTrainerSlugServicesSlugIndexRoute,publicTrainerSlugShopProductIdIndexRoute: publicTrainerSlugShopProductIdIndexRoute
}

const publicTrainerSlugRouteRouteWithChildren = publicTrainerSlugRouteRoute._addFileChildren(publicTrainerSlugRouteRouteChildren)

const rootRouteChildren = {
  privateRouteRoute: privateRouteRouteWithChildren,OnboardingRouteRoute: OnboardingRouteRouteWithChildren,publicTrainerSlugRouteRoute: publicTrainerSlugRouteRouteWithChildren,publicIndexRoute: publicIndexRoute,ConsentIndexRoute: ConsentIndexRoute,publicHelpSlugRoute: publicHelpSlugRoute,publicTSplatRoute: publicTSplatRoute,publicBlogIndexRoute: publicBlogIndexRoute,publicCallbackIndexRoute: publicCallbackIndexRoute,publicCoachesIndexRoute: publicCoachesIndexRoute,publicConsumerHealthDataIndexRoute: publicConsumerHealthDataIndexRoute,publicContactIndexRoute: publicContactIndexRoute,publicContentPolicyIndexRoute: publicContentPolicyIndexRoute,publicCookiesIndexRoute: publicCookiesIndexRoute,publicFeaturesIndexRoute: publicFeaturesIndexRoute,publicHelpIndexRoute: publicHelpIndexRoute,publicHowItWorksIndexRoute: publicHowItWorksIndexRoute,publicJoinIndexRoute: publicJoinIndexRoute,publicLegalIndexRoute: publicLegalIndexRoute,publicLoginIndexRoute: publicLoginIndexRoute,publicLogoutIndexRoute: publicLogoutIndexRoute,publicNewPasswordIndexRoute: publicNewPasswordIndexRoute,publicPricingIndexRoute: publicPricingIndexRoute,publicPrivacyIndexRoute: publicPrivacyIndexRoute,publicSearchIndexRoute: publicSearchIndexRoute,publicSignupIndexRoute: publicSignupIndexRoute,publicTermsIndexRoute: publicTermsIndexRoute,publicWhoItsForIndexRoute: publicWhoItsForIndexRoute,publicWithdrawalIndexRoute: publicWithdrawalIndexRoute,publicBlogAuthorAuthorSlugRoute: publicBlogAuthorAuthorSlugRoute,publicBlogCategoryCategorySlugRoute: publicBlogCategoryCategorySlugRoute,publicBlogSlugIndexRoute: publicBlogSlugIndexRoute,publicBookingConfirmIndexRoute: publicBookingConfirmIndexRoute,publicBookingVerifyIndexRoute: publicBookingVerifyIndexRoute,publicSearchServiceIndexRoute: publicSearchServiceIndexRoute,publicSearchServiceCityIndexRoute: publicSearchServiceCityIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)